// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_3GcWIAi","list":"_2JwYR9n","list__animate":"DfrfywO","carouselLink":"_1Fg6Mkn _3GcWIAi"};